import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { IFilterValue, IFilterValues, IProfessioalData } from "domain/order";
import useDebounce from "hooks/useDebounce";
import RoamingItemsFilterColumns from "./RoamingItemsClientFilter";
import { motion, AnimatePresence } from "framer-motion";

const RoamingItemsClientTable: React.FC<any> = ({
  loading,
  pagination,
  setPagination,
  data,
  setFilters,
  onAddItem,
}) => {
  const [tableData, setTableData] = useState<IProfessioalData[]>(data);
  const [searchValues, setSearchValues] = useState<IFilterValues>({});
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const debouncedSearchValue = useDebounce(searchValues, 900);
  useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>, dataIndex: string) => {
    const value = e.target.value;
    setSearchValues((prevSearchValues: IFilterValues) => ({
      ...prevSearchValues,
      [dataIndex]: value,
    }));
  };
  const columns = [
    // {
    //   title: "",
    //   key: "action",
    //   width: 50,
    //   render: (_: any, record: IProfessioalData) => (
    //     <Tooltip title="Add as roaming item">
    //       <PlusOutlined
    //       disabled={true}
    //         style={{ color: "#1890ff", cursor: "pointer", fontSize: 16 }}
    //         onClick={() => onAddItem?.(record)}
    //       />
    //     </Tooltip>
    //   ),
    // },
    { title: 'Customer Site', dataIndex: 'CustomerSite', key: 'CustomerSite' },
    { title: 'Price', dataIndex: 'Price', key: 'Price' },
    { title: 'Sell Price', dataIndex: 'SellPrice', key: 'SellPrice' },
    { title: 'In Stock', dataIndex: 'InStock', key: 'InStock' },
  ];

  const nestedTableColumns = [
    { title: 'RFID', dataIndex: 'RFID', key: 'RFID' },
    { title: 'Date Added', dataIndex: 'DateAdded', key: 'DateAdded' },
    { title: 'No Cycles', dataIndex: 'NoCycles', key: 'NoCycles' },
  ]

  const handlePageChange = (page: number, pageSize?: number) => {
    const newPagination = { ...pagination, current: page, pageSize: pageSize || pagination.pageSize };
    setPagination(newPagination);
  };

  useEffect(() => {
    const searchFilters = { ...debouncedSearchValue };
    const cleanedFilters: IFilterValue = Object.fromEntries(
      Object.entries(searchFilters)
        .filter(([_, value]) => value !== "" && value != null)
        .map(([key, value]) => [key, String(value)])
    );
    setPagination({ ...pagination, current: 1 });
    if (setFilters) {
      setFilters(cleanedFilters);
    }
  }, [debouncedSearchValue]);

  return (
    <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
      <motion.div
        animate={{ flex: selectedRow ? 0.6 : 1 }}
        transition={{ duration: 0.4 }}
        style={{ overflow: "hidden" }}
      >
        <Table
          scroll={{ x: "max-content" }}
          loading={loading}
          className="redesign-table order-by-professional-table"
          dataSource={tableData}
          columns={RoamingItemsFilterColumns({
            columns: columns,
            searchValues,
            handleFilterChange,
          })}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total || 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "50", "100"],
            onChange: handlePageChange,
          }}
          onRow={(record: any) => ({
            onClick: () =>
              setSelectedRow(
                selectedRow?.CustomerSite === record?.CustomerSite
                  ? null
                  : record
              ),
          })}
          rowClassName={(record: any) =>
            record.CustomerSite === selectedRow?.CustomerSite
              ? "selected-row"
              : ""
          }
        />
      </motion.div>

      <AnimatePresence>
        {selectedRow && (
          <motion.div
            key="nestedTable"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0, flex: 0.4 }}
            exit={{ opacity: 0, x: 30, flex: 0 }}
            transition={{ duration: 0.4 }}
            style={{ overflow: "hidden" }}
          >
            <Table
              scroll={{ x: "max-content" }}
              loading={loading}
              className="redesign-table order-by-professional-table"
              dataSource={
                selectedRow?.nestedData || []
              }
              columns={nestedTableColumns}
              pagination={false}
              title={() => `Details for ${selectedRow.CustomerSite}`}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RoamingItemsClientTable;